import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export function getAmortizationReports(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getAmortizationReport${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getAmortizationReportsExcel(query, options) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getAmortizationReport${q}`, options);
}
